<template>
  <div id="productItem" class="productItem-container" @click="handleClick">
    <!--img container-->
    <div class="imgContainer" :style="{backgroundImage: `url(${img})`}">
      <img v-if="isHot" class="hot" :src="imgHot" />
    </div>
    <div class="labelContainer">
      {{text}}
    </div>
  </div>
</template>
<script>
  import ImgHot from "@/assets/img/product/hot.png"
  export default {
    name: "ProductItem",
    props: {
      id: { type: String, default: "" },
      img: { type: String, default: "" },
      text: { type: String, default: "" },
      isHot: { type: Boolean, default: false }
    },
    data() {
      return {
        imgHot: ImgHot
      };
    },
    methods: {
      handleClick() {
        this.$emit("click", this.id)
      }
    }
  };
</script>
<style scoped>
  .productItem-container {
    width: 283px;
    height: 400px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    cursor: pointer;
  }

    .productItem-container .imgContainer {
      position: relative;
      width: 283px;
      height: 364px;
      background: #FFFFFF;
      box-shadow: 0px 3px 14px 0px rgba(0,0,0,0.07);
      border-radius: 5px;
      border: 2px solid #77B1FF00;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }

      .productItem-container .imgContainer .hot {
        position: absolute;
        top: -2px;
        right: -2px;
        width: 49px;
        height: 44px;
      }

    .productItem-container .labelContainer {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 20px;
      color: #222222;
      line-height: 1.3;
      text-align: center;
      margin-top: 20px;
    }

    .productItem-container:hover .imgContainer {
      border-radius: 5px;
      border: 2px solid #77B1FF;
    }

    .productItem-container:hover .labelContainer {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 20px;
      color: #006DFF;
    }


  @media screen and (max-width: 768px) {
    .productItem-container {
      width: 40vw;
      height: 49vw;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      cursor: pointer;
      margin-bottom: 61px;
    }

      .productItem-container .imgContainer {
        width: 100%;
        height: 100%;
      }

      .productItem-container .labelContainer {
        font-size: 18px;
      }
  }
</style>




// WEBPACK FOOTER //
// src/components/productItem/productItem.vue